import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

import {
  SEARCH_SUGGESTED_PRODUCTS,
  CREATE_SUGGESTED_PRODUCT,
  UPDATE_SUGGESTED_PRODUCT,
  DELETE_SUGGESTED_PRODUCT,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT,
} from '../constants/ActionsTypes'

import {
  searchSuggestedProducts as searchSuggestedProductsApi,
  createSuggestedProduct as createSuggestedProductApi,
  updateSuggestedProduct as updateSuggestedProductApi,
  deleteSuggestedProduct as deleteSuggestedProductApi,
  searchSuggestedProductsByClient as searchSuggestedProductsByClientApi,
} from '../api/SuggestedProducts'

import {
  searchSuggestedProductsSuccess,
  searchSuggestedProductsError,
  createSuggestedProductSuccess,
  createSuggestedProductError,
  updateSuggestedProductSuccess,
  updateSuggestedProductError,
  deleteSuggestedProductSuccess,
  deleteSuggestedProductError,
  searchSuggestedProducts as searchSuggestedProductsAction,
  searchSuggestedProductsByClientSuccess,
  searchSuggestedProductsByClientError,
} from '../actions/SuggestedProducts'

import { showMessages } from '../actions'

function* searchSuggestedProductsRequest({ payload }) {
  try {
    const result = yield call(searchSuggestedProductsApi, payload)
    yield put(searchSuggestedProductsSuccess(result))
  } catch (error) {
    yield put(searchSuggestedProductsError(error))
  }
}

function* createSuggestedProductRequest({ payload }) {
  try {
    yield call(createSuggestedProductApi, payload)
    yield put(createSuggestedProductSuccess())
    yield put(showMessages({ summary: 'Suggested product created', type: 'success' }))
    yield put(searchSuggestedProductsAction({ page: 1, pageSize: 10 }))
  } catch (error) {
    yield put(createSuggestedProductError(error))
  }
}

function* updateSuggestedProductRequest({ payload }) {
  try {
    yield call(updateSuggestedProductApi, payload)
    yield put(updateSuggestedProductSuccess())
    yield put(showMessages({ summary: 'Suggested product updated', type: 'success' }))
    yield put(searchSuggestedProductsAction({ page: 1, pageSize: 10 }))
  } catch (error) {
    yield put(updateSuggestedProductError(error))
  }
}

function* deleteSuggestedProductRequest({ payload }) {
  try {
    yield call(deleteSuggestedProductApi, payload)
    yield put(deleteSuggestedProductSuccess())
    yield put(showMessages({ summary: 'Suggested product deleted', type: 'success' }))
    yield put(searchSuggestedProductsAction({ page: 1, pageSize: 10 }))
  } catch (error) {
    yield put(deleteSuggestedProductError(error))
  }
}

export function* searchSuggestedProductsSaga() {
  yield takeEvery(SEARCH_SUGGESTED_PRODUCTS, searchSuggestedProductsRequest)
}

export function* createSuggestedProductSaga() {
  yield takeEvery(CREATE_SUGGESTED_PRODUCT, createSuggestedProductRequest)
}

export function* updateSuggestedProductSaga() {
  yield takeEvery(UPDATE_SUGGESTED_PRODUCT, updateSuggestedProductRequest)
}

export function* deleteSuggestedProductSaga() {
  yield takeEvery(DELETE_SUGGESTED_PRODUCT, deleteSuggestedProductRequest)
}

function* searchSuggestedProductsByClientRequest({ payload }) {
  try {
    const result = yield call(searchSuggestedProductsByClientApi, payload)
    yield put(searchSuggestedProductsByClientSuccess(result, payload?.displayLocation))
  } catch (error) {
    yield put(searchSuggestedProductsByClientError(error, payload?.displayLocation))
  }
}

export function* searchSuggestedProductsByClientSaga() {
  yield takeEvery(SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT, searchSuggestedProductsByClientRequest)
}

export default function* rootSaga() {
  yield all([
    fork(searchSuggestedProductsSaga),
    fork(createSuggestedProductSaga),
    fork(updateSuggestedProductSaga),
    fork(deleteSuggestedProductSaga),
    fork(searchSuggestedProductsByClientSaga),
  ])
}
